// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.video-platform__section[data-v-43882012] {\n  border-radius: 3px;\n  background-color: #e2d2bb;\n}\n.pt-apply__police-note[data-v-43882012] {\n  margin-top: 10px;\n}\n.pt-apply__cancel-policy[data-v-43882012] {\n  margin-top: 10px;\n}\n.pt-apply__apply-btn[data-v-43882012] {\n  min-width: 180px;\n}\n.video-platform__text[data-v-43882012] {\n  padding: 8px;\n}\n", ""]);
// Exports
module.exports = exports;
